class Event {
  _init = async () => {
    return true
  }

  resolve = async (event, data = null) => {
    let _event = {}
    if (!event.type) {
      event = {
        type: event,
        detail: data
      }
    }

    if (event.cookie) _$.vue.$emit(`event${event.cookie}`, event)
    if (event.cookie > -1) return false

    /* Platform-specific Event */
    if (event.type === "ApplicationControl" && event.detail.ActiveApplications) {
      if (__.device.power === "standby") return

      const activeApps = event.detail.ActiveApplications.filter(rec => !rec.ApplicationName.includes("VolumeControl")).map(rec => rec.ApplicationName)
      const activeApp = activeApps.shift()
      if (!activeApp && __.device.power === "on") return __._app.launch("CustomDashboard")

      switch (activeApp) {
        case "CustomDashboard":
          _event.name = "applicationFocusing"
          await _$.sleep(1000).then(() => __._device.registerKeys())
          break
        default:
          _event.name = "applicationUnfocused"
          __._device.registerKeys(["VK_LEFT", "VK_RIGHT", "VK_DOWN", "VK_UP", "VK_BACK", "VK_ACCEPT"])
          break
      }
    } else if (event.type === "Source") {
      _event.name = "source"
      _event.data = event.detail.TunedSource

      if (__.source.current === _event.data) return false
    } else if (event.type === "ChannelSelection") {
      let state = event.detail

      if (state.ChannelSelectionStatus === "Successful" && state.ChannelPlayingStatus === "Playing") {
        __._source.lastChannel = state?.ChannelTuningDetails?.URL || null
        if (!__.media.source) return __._multicast.stop()
        else if (__.media.status === "playing") return false
        _event.name = "mediaPlaying"
      } else if (state.ChannelSelectionStatus === "Failure") _event.name = "mediaError"
      else if (state.ChannelSelectionStatus === "Stopped") _event.name = "mediaStopped"
      else return false
    } else if (["playing", "ended", "stopped", "pause", "error"].indexOf(event.type) >= 0) {
      let tempName
      switch (event.type) {
        case "playing":
          if (__.media.status === "playing") return false
          tempName = "mediaPlaying"
          break
        case "ended":
          tempName = "mediaEnded"
          break
        case "pause":
          tempName = "mediaPaused"
          break
        case "stopped":
          tempName = "mediaStopped"
          break
        default:
          tempName = "mediaError"
          break
      }
      _event.name = tempName
    } else if (event.type === "PowerState") {
      const { Transition, CurrentPowerState } = event.detail

      if (Transition === "Yes") return false
      _event.name = "power"
      _event.data = CurrentPowerState.toLowerCase()
    } else if (event.type === "messageEvent") {
      let socketData = null
      try {
        socketData = window.atob(event.detail)
        socketData = JSON.parse(socketData)
      } catch (e) {
        return _$.error(e)
      }

      if (socketData.hasOwnProperty("action")) _$.vue.$emit("action", socketData)
      else if (socketData.hasOwnProperty("weather")) _$.vue.$emit("weather", socketData)
      else if (socketData.hasOwnProperty("chromecast")) _$.vue.$emit("chromecast", socketData)
      else if (socketData.hasOwnProperty("rc")) _$.vue.$emit("rc-command", socketData)
      return false
    }
    return _event
  }
}

export default Event
